import {
  getPowerappsWithApprovalCounts,
  getPowerappApprovals,
  getArchivedApprovals,
  approveManagerApproval,
  declineManagerApproval,
  getApprovalHistory,
  getApprovalStatus,
  getAgentPowerappsWithApprovals,
  getAgentPowerappApprovals
} from "../../api";
import useManagerApprovalStore from "../stores/managerApproval";

export const fetchPowerappsWithApprovalCounts = async (organizationId, params = {}) => {
  try {
    const response = await getPowerappsWithApprovalCounts({
      params: { 
        organization_id: organizationId,
        page: params.page,
        per_page: params.per_page,
        search: params.search,
        sort: params.sort,
        sort_direction: params.sort_direction
      }
    });
    if (response.status) {
      const store = useManagerApprovalStore.getState();
      store.setPowerappsWithApprovals(response.data || []);

      if (response.pagination) {
        store.setCurrentPage(response.pagination.current_page);
        store.setPageCount(response.pagination.last_page);
        store.setTotalItems(response.pagination.total);
        store.setItemsPerPage(response.pagination.per_page);
      }
    }
    return response;
  } catch (error) {
    console.error("Error fetching powerapps with approval counts:", error);
    throw error;
  }
};

export const fetchArchivedApprovals = async ({ organization_id, page, per_page, search, sort, sort_direction }) => {
  try {
    const response = await getArchivedApprovals({
      params: { organization_id: organization_id, page, per_page, search, sort, sort_direction }
    });
    if (response.status) {
      const store = useManagerApprovalStore.getState();
      store.setArchivedApprovals(response.data || []);
      
      // Handle pagination metadata
      if (response.pagination) {
        store.setCurrentPage(response.pagination.current_page);
        store.setPageCount(response.pagination.last_page);
        store.setTotalItems(response.pagination.total);
        store.setItemsPerPage(response.pagination.per_page);
      }
    }
    return response;
  } catch (error) {
    console.error("Error fetching archived approvals:", error);
    throw error;
  }
};

export const fetchApprovalHistory = async (params) => {
  try {
    const store = useManagerApprovalStore.getState();
    const response = await getApprovalHistory({
      params: {
        organization_id: params.organization_id,
        status: params.status,
        action_type: params.action_type,
        page: params.page || store.currentPage,
        per_page: params.per_page || store.itemsPerPage
      }
    });

    if (response.status) {
      store.setApprovalHistory(response.data || []);
      if (response.pagination) {
        store.setPageCount(response.pagination.last_page);
        store.setCurrentPage(response.pagination.current_page);
        store.setTotalItems(response.pagination.total);
        store.setItemsPerPage(response.pagination.per_page);
      }
    } else {
      store.setApprovalHistory([]);
      store.setPageCount(1);
      store.setCurrentPage(1);
      store.setTotalItems(0);
      store.setItemsPerPage(20);
    }
    return response;
  } catch (error) {
    console.error("Error fetching approval history:", error);
    throw error;
  }
};

export const approveApproval = async (approvalId, notes = '') => {
  try {
    const response = await approveManagerApproval({
      approval_id: approvalId,
      notes
    });
    return response;
  } catch (error) {
    console.error("Error approving manager approval:", error);
    throw error;
  }
};

export const declineApproval = async (approvalId, notes) => {
  try {
    const response = await declineManagerApproval({
      approval_id: approvalId,
      notes
    });
    return response;
  } catch (error) {
    console.error("Error declining manager approval:", error);
    throw error;
  }
};

export const fetchPowerappApprovals = async ({ powerappId, params = {} }) => {
  try {
    const response = await getPowerappApprovals({
      powerappId,
      params
    });
    if (response.status) {
      const store = useManagerApprovalStore.getState();
      store.setPowerappApprovals(response.data || []);
      store.setSelectedPowerapp(response.powerapp || {});      
    }
    return response;
  } catch (error) {
    console.error("Error fetching powerapp approvals:", error);
    throw error;
  }
};

export const fetchApprovalStatus = async (powerappId, params = {}) => {
  try {
    const response = await getApprovalStatus({
      powerappId,
      params: {
        ...params,
        organization_id: useManagerApprovalStore.getState().organizationId
      }
    });
    if (response.status) {
      const store = useManagerApprovalStore.getState();
      store.setApprovalStatus(response.data || {});
    }
    return response;
  } catch (error) {
    console.error("Error fetching approval status:", error);
    throw error;
  }
};

export const fetchAgentPowerappsWithApprovals = async (params = {}) => {
  try {
    const response = await getAgentPowerappsWithApprovals({
      params: {
        page: params.page,
        per_page: params.per_page
      }
    });
    if (response.status) {
      const store = useManagerApprovalStore.getState();
      store.setPowerappsWithApprovals(response.data || []);

      if (response.pagination) {
        store.setCurrentPage(response.pagination.current_page);
        store.setPageCount(response.pagination.last_page);
        store.setTotalItems(response.pagination.total);
        store.setItemsPerPage(response.pagination.per_page);
      }
    }
    return response;
  } catch (error) {
    console.error("Error fetching agent powerapps with approvals:", error);
    throw error;
  }
};
export const fetchAgentPowerappApprovals = async ({ powerappId, params = {} }) => {
  try {
    const response = await getAgentPowerappApprovals({
      powerappId,
      params
    });
    if (response.status) {
      const store = useManagerApprovalStore.getState();
      store.setPowerappApprovals(response.data || []);
      store.setSelectedPowerapp(response.powerapp || {});
      
      // Handle pagination
      if (response.pagination) {
        store.setCurrentPage(response.pagination.current_page);
        store.setPageCount(response.pagination.last_page);
        store.setTotalItems(response.pagination.total);
        store.setItemsPerPage(response.pagination.per_page);
      }
    }
    return response;
  } catch (error) {
    console.error("Error fetching agent powerapp approvals:", error);
    throw error;
  }
};
